// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthRevokeRequestSchema = z.object({
  token: z.coerce.string().min(1).describe("OAuth 2.0 access or refresh token to revoke"),
  token_type_hint: z.enum(["access_token", "refresh_token"]).describe("Hint about the type of token being revoked").nullish(),
  client_id: z.coerce.string().describe("OAuth 2.0 client identifier").nullish(),
  client_secret: z.coerce.string().describe("OAuth 2.0 client secret").nullish(),
});
